import { CIBUS_CODE_PREFIX, TENBIS_CODE_PREFIX, type OrderView } from 'shared-models/browser';

// The channel note that must reach the printed bon; null for a non-aggregator order.
export function aggregatorOrderNote(
  order: Partial<Pick<OrderView, 'tenbisNote' | 'cibusNote'>> & { orderCode?: string | null },
): string | null {
  if (order.orderCode?.startsWith(CIBUS_CODE_PREFIX)) {
    return order.cibusNote ?? null;
  }
  if (order.orderCode?.startsWith(TENBIS_CODE_PREFIX)) {
    return order.tenbisNote ?? null;
  }
  return null;
}
